export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16 doc-pb28">更新日期：2021年12月3日</div>

    <div class="doc-text">*提示</div>
    <div class="doc-text doc-pb28">本服务协议内容包括服务条款、免责声明两部分。请您务必认真阅读、充分理解本协议。您确认您具备完全民事权利能力和完全民事行为能力，有能力阅读、同意并遵守本协议，并对您本协议项下的全部行为独立承担法律责任。</div>

    <div class="doc-text doc-pb28">
      <a class="doc-link" href="javascript:void(0);">《盈宝隐私政策》</a>
      以及盈宝公布的其他协议规范、规则、声明、公告、政策等（以下统称“其他盈宝规则”）是本协议不可分割的组成部分，您在使用盈宝服务时应同样遵守。您接受并同意本协议的行为即视为您同意并接受其他盈宝规则，您接受并同意任一其他盈宝规则的行为亦视为您接受并同意本协议。
    </div>

    <div class="doc-text doc-pb28">若您下载、安装、使用或接入盈宝软件，即表示确认及同意本协议项下所有条款。盈宝手机应用APP有权于任何时间修改或变更本服务协议之内容，建议您随时注意修改或变更。您于任何修改或变更后继续使用本应用时，将视为您已阅读、了解并同意接受该等修改或变更。</div>

    <div class="doc-text doc-pb28">如您不同意本协议任意内容，请不要注册或使用盈宝相关服务。如您通过注册程序，即表示您与盈宝达成协议，自愿接受相关服务条款、免责声明以及隐私政策等所有协议内容。此后，用户不得以未阅读本协议内容作任何形式的抗辩。</div>

    <div class="doc-text">您在使用盈宝某特定服务时，该服务可能会另有单独的协议、相关业务规则等，使用该项服务前请阅读并同意相关的单独协议。您使用前述特定服务，即视为您接受相关单独协议</div>

    <div class="doc-main-title">服务条款</div>

    <div class="doc-text doc-pb28">您在使用盈宝某特定服务时，该服务可能会另有单独的协议、相关业务规则等，使用该项服务前请阅读并同意相关的单独协议。您使用前述特定服务，即视为您接受相关单独协议和相应的业务规则。</div>

    <div class="doc-text doc-pb28">（一）盈宝软件使用说明</div>
    <div class="doc-text doc-pb28">盈宝授权您个人一项有限的、可撤销的、不可转让的、不可转授权的及非排他性的使用盈宝软件的许可。您仅可出于访问或使用本软件提供之服务的目的而使用，本协议未授权的其他一切权利仍由盈宝保留。</div>

    <div class="doc-text doc-pb28">（二）软件的获取、安装及更新</div>
    <div class="doc-text doc-pb28">1. 您可以直接从盈宝官网等渠道下载盈宝软件，也可以从得到盈宝授权的第三方获取。若您从未经合法授权的第三方获取盈宝软件，盈宝无法保证该软件的安全性和正常使用，亦不承担由此造成的任何不利后果。</div>
    <div class="doc-text doc-pb28">2. 盈宝为不同的终端设备开发了不同的盈宝软件版本，您应当根据实际情况选择下载合适的版本进行安装。</div>
    <div class="doc-text doc-pb28">3. 为了提升用户体验、完善服务内容、保证服务的安全性，我们有权随时对软件进行更新或者对软件的部分功能效果进行改变或限制。</div>

    <div class="doc-text doc-pb28">（三）请您正确使用盈宝软件，不得：</div>
    <div class="doc-text doc-pb28">1. 自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</div>
    <div class="doc-text doc-pb28">2. 对盈宝拥有所有权或知识产权的内容进行使用、出租、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</div>
    <div class="doc-text doc-pb28">3. 其他未经盈宝明示授权的行为。</div>

    <div class="doc-text doc-pb28">（四）用户行为规范</div>
    <div class="doc-text doc-pb28">您应对注册获得的盈宝用户账号（以下简称“账号”）项下的一切行为承担全部责任，同意不利用盈宝软件和盈宝服务从事下列行为，否则我们有权对违反本协议内容的用户作出禁止注册及/或封号的处理：</div>
    <div class="doc-text doc-pb28">1. 发布、传送、传播、储存违反证券法规及相关证券交易所规则的信息，无论故意与否；</div>
    <div class="doc-text doc-pb28">2. 发布、传送、传播、储存违反国家及当地法律法规的内容；</div>
    <div class="doc-text doc-pb28">3. 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</div>
    <div class="doc-text doc-pb28">4. 发布、传送、传播、储存侵犯其他用户或第三方合法权益内容的信息；</div>
    <div class="doc-text doc-pb28">5. 发布、传送、传播、储存涉及他人隐私、个人信息或资料的内容；</div>
    <div class="doc-text doc-pb28">6. 发布、传送、传播骚扰信息、广告信息、垃圾信息、或含有任何性或性暗示信息的内容；</div>
    <div class="doc-text doc-pb28">7. 发布、传送、传播谣言、虚假信息或其他含有不实信息的内容；</div>
    <div class="doc-text doc-pb28">8. 发布、传送、传播、储存干扰盈宝软件和服务正常运营的信息；</div>
    <div class="doc-text doc-pb28">9. 发布、传送、传播、储存其他违反法律法规、政策及公序良俗、社会公德的信息。</div>

    <div class="doc-text doc-pb28">（五）用户注意</div>
    <div class="doc-text doc-pb28">1. 盈宝软件使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。</div>
    <div class="doc-text doc-pb28">2. 您应妥善保管账号信息、账号密码以及其他与账号相关的信息、资料。如因您的原因，造成账号信息、资料、数据的变动、灭失或财产损失等，您应立即通知盈宝并自行承担相关法律后果。</div>
    <div class="doc-text doc-pb28">3. 盈宝会尽其商业上的合理努力保障您在盈宝软件和盈宝服务中的数据存储安全。</div>
    <div class="doc-text doc-pb28">4. 在任何情况下，请不要应轻信借款、索要密码或其他涉及财产的信息。涉及财产操作的，请务必事前进行核实及确认，并请经常留意相关防范诈骗犯罪的提示。</div>
    <div class="doc-text doc-pb28">5. 手机应用包含的内容和信息是根据公开资料分析和演释，该公开资料是从可靠来源搜集，手机应用竭力确保所提供信息的准确和可靠度，但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任（不管是否侵权法下的责任或合约责任又或其它责任）。手机应用的行情价格、图表仅作为购买或出售的参考依据，请您谨慎对待。</div>
    <div class="doc-text doc-pb28">6. 手机应用对于您手机应用链接到其它网站而下载的软件或资料或使用的服务，不负任何担保责任。您应于下载和使用前自行斟酌与判断前述软件、服务或资料的合法合规性、合适性、有效性、正确性、完整性及是否侵害他人权利，以免遭受损失(例如: 造成您电脑系统受损或储存资料流失等)，手机应用对于该等损失不负任何赔偿责任。</div>
    <div class="doc-text doc-pb28">7. 手机应用随时会与其它公司合作，并由其提供包括新闻、资讯、电子报等不同的内容供网站及手机应用刊登，手机应用在刊登时均将注明内容提供者。基于尊重内容提供者之知识产权，手机应用对其提供之内容并不做实质之审查或修改，对该等内容之正确真伪亦不负任何责任。对该等内容之正确真伪，您应自行判断。您若认为某些内容涉及侵权或有所不实，请径自向该内容提供者反映意见。</div>
    <div class="doc-text doc-pb28">8. 手机应用所使用的软件或程序、手机应用上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构，均由手机应用或其他权利人依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密与专有技术等。任何人不得擅自实施使用、修改、重制、公开播送、改作、散布、发行、公开发表、进行还原工程、解编或反向组译等侵权行为。若您准备引用或转载前述软件、程序内容，必须依法取得手机应用或其他权利人的事前书面同意。尊重知识产权为您应尽的义务，如有违反，您应对手机应用、其他权利人负损害赔偿责任(包括但不限于诉讼费及律师费等)。如因您的行为造成盈宝遭受其他权利人追诉的，盈宝有权向您追究一切法律责任。</div>
    <div class="doc-text doc-pb28">9. 就本服务提供过程中的任何证券交易所的行情信息（以下称"行情信息"），您保证和承诺不以任何方式复制或向任何机构或个人提供全部或部分该等行情信息，保证不以任何方式将全部或部分行情信息用于非法目的，保证不将全部或部分行情信息用于开发衍生产品，保证不对提供服务的软件产品进行破解。您同意并保证不得利用本服务从事侵害他人权益或违法之行为。如用户未能遵守本文中关于行情信息的条款及细则，盈宝将在任何時间自动终止和切断行情数据的流动，並不承担任何法律责任和/或向用户提供任何补偿。</div>
    <div class="doc-text">10. 您同意并承诺不会将盈宝软件或盈宝服务提供的市场数据的全部或其任何部分以任何方式再行发布或传播，或用于指数计算和汇编，或用于导出任何可交易产品，或用于其他任何目的。</div>

    <div class="doc-main-title">免责声明</div>

    <div class="doc-text doc-pb28">1. 您确认并承诺在使用盈宝软件或在接受盈宝服务时，您应对金融市场常识有一定的了解，并充分知悉相关市场风险。</div>

    <div class="doc-text doc-pb28">2. 您理解并同意，盈宝不保证盈宝服务一定能满足您的要求，也不保证服务不会中断，对服务的及时性、准确性不作保证。您使用盈宝软件及盈宝服务所存在或导致的风险将完全由您自己承担。您因使用盈宝服务而产生的一切后果也由您自己承担，盈宝对您不承担任何责任，该等风险或后果包括但不限于：</div>
    <div class="doc-text doc-pb28">(1) 因计算机病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为及其他不可抗力等因素导致的服务中断、数据或资料丢失、泄露或损毁以及其他的损失和风险；</div>
    <div class="doc-text doc-pb28">(2) 您或盈宝的电脑软件、系统、硬件和通信线路出现故障导致的服务中断、数据或资料丢失、泄露或损毁以及其他的损失和风险；</div>
    <div class="doc-text doc-pb28">(3) 您操作不当或通过非盈宝授权的方式使用盈宝服务带来的损失和风险；</div>
    <div class="doc-text doc-pb28">(4) 您通过盈宝软件中的链接访问第三方网站时，因第三方网站及内容所可能带来的损失和风险；</div>
    <div class="doc-text doc-pb28">(5) 您的上传内容被他人转发、分享，因此等传播可能带来的风险和责任；</div>
    <div class="doc-text doc-pb28">(6) 由于网络信号不稳定、网络带宽小等原因，所引起的登录失败、资料同步不完整、页面打开速度慢可能带来的风险和责任；</div>

    <div class="doc-text">3. 通过对任何市场数据的使用，您同意并确认:</div>
    <div class="doc-text doc-pb28">香港交易所资讯服务有限公司、其控股公司及／或该等控股公司的任何附属公司尽力保证所提供信息的准确和可靠度，但不能确保其绝对准确和可靠，亦不对因信息不准确或遗漏而导致的任何损失或损害承担责任（不管是否侵权法下的责任或合约责任又或其他责任）。</div>

    <div class="doc-text doc-pb28">4. 手机应用所载或透过该平台所存取的任何数据及材料仅供一般参考之用，不应被视为投资意见，并且不应作为作出商业决定的基础。尽管盈宝将致力确保数据的准确性，但盈宝对任何错误或遗漏概不承担任何责任。</div>

    <div class="doc-text doc-pb28">5. 手机应用所载或透过该平台存取的数据及材料在任何司法管辖区内均不构成任何证券、金融产品或工具要约、招揽、建议、意见或任何保证。</div>

    <div class="doc-text doc-pb28">6. 手机应用的信息和内容是基于（现况）及（现有）提供，如有更改恕不另行通知，请您密切关注手机应用最新动态。</div>

    <div class="doc-text doc-pb28">7. 盈宝对于任何从手机应用有关服务所获得的资讯、内容或广告，不声明或保证其内容之正确性或可靠性。对于您透过本手机应用上之广告、资讯或邀约而展示、购买或取得之任何产品、资讯资料，盈宝亦不负品质保证之责任。</div>

    <div class="doc-text doc-pb28">8. 手机应用也许链接用户有兴趣的网站，尽管上述信息乃基于盈宝认为可靠的来源，但盈宝并不保证其准确性，而信息亦可能属于不完整或过时。接入第三方网站链接的风险概由用户自行承担。盈宝不会调查、核实、监察或赞同其内容、准确性、所表达的意见，以及该等资源提供的其他连结。</div>

    <div class="doc-text doc-pb28">9. 鉴于互联网的特性，手机应用所提供的服务有时可能会出现中断、故障等不可抗力现象，或许将造成您使用上的不便、资料丢失、错误、遭人篡改或其它经济上损失等情形。您在使用手机应用所提供的服务时应自行采取防护措施。手机应用对您因上述原因使用(或无法使用)本手机应用所提供的服务而造成的损害，不负任何赔偿责任。</div>

    <div class="doc-text doc-pb28">针对以上各种风险，希望您学会自我保护，掌握适当的电脑和手机操作经验和安全防范知识，一旦发现账户或手机异常，尽快与盈宝取得联系妥善处理。</div>
  </div>
`
